var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.useButton)?_c('div',{class:_vm.containerClass,attrs:{"id":"return-to-top-container"}},[_c('v-btn',{attrs:{"id":"return-to-top-button","fab":"","small":"","color":"primary"},on:{"click":_vm.returnToTop}},[_c('v-icon',[_vm._v(" mdi-chevron-up ")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }